import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VehicleBookingService {

  constructor(private http: HttpClient) { }

  getAllBookingVehicles(data:any){
    return this.http.post(environment.apiUrl + "vehiclesbooking/get/pagination" , data)
  }

  updateVehicleBooking(data:any){
    return this.http.post(environment.apiUrl + "vehiclesbooking/update" , data)
  }
}
